export default function accounting(x) {
	return x
		? Number.parseFloat(x)
				.toFixed(2)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
		: '0.00'
}
